import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { FIELD_ID, FILTERS_TYPE, GROUP_ID } from 'app/constants/BrowseConstants';
import { displayBibMapShape } from 'app/shapes/displayBib';

// UI category config
export const uiCategoryConfigMapShape = ImmutablePropTypes.mapContains({
  bibsByCategoryPath: ImmutablePropTypes.mapOf(ImmutablePropTypes.listOf(displayBibMapShape), PropTypes.string)
    .isRequired,
  categoryByPath: ImmutablePropTypes.mapOf(
    ImmutablePropTypes.mapContains({
      categoryId: PropTypes.string.isRequired,
      isEnabled: PropTypes.bool.isRequired,
      path: PropTypes.string.isRequired,
      parentPath: PropTypes.string,
      searchUrl: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      subCategoryPaths: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
      title: PropTypes.string.isRequired
    }),
    PropTypes.string
  ).isRequired,
  categoryPath: PropTypes.string.isRequired,
  isLeaf: PropTypes.bool.isRequired,
  searchQueryParams: ImmutablePropTypes.mapContains({
    filters: ImmutablePropTypes.mapOf(ImmutablePropTypes.listOf(PropTypes.string), PropTypes.string).isRequired,
    searchScope: PropTypes.string,
    searchType: PropTypes.string.isRequired,
    sort: PropTypes.string
  })
});

// facets
const fieldIdShape = PropTypes.oneOf(Object.values(FIELD_ID));
const groupIdShape = PropTypes.oneOf(Object.values(GROUP_ID));

export const filterShape = PropTypes.shape({
  fieldId: fieldIdShape.isRequired,
  filterId: PropTypes.string.isRequired,
  groupId: groupIdShape.isRequired,
  isApplied: PropTypes.bool.isRequired,
  isExclusive: PropTypes.bool.isRequired,
  isShown: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired
});

export const groupShape = PropTypes.shape({
  groupId: groupIdShape.isRequired,
  filters: PropTypes.arrayOf(filterShape).isRequired,
  filtersType: PropTypes.oneOf(Object.values(FILTERS_TYPE)).isRequired,
  label: PropTypes.string.isRequired
});

export const fieldShape = PropTypes.shape({
  fieldId: fieldIdShape.isRequired,
  hasMore: PropTypes.bool.isRequired,
  groups: PropTypes.arrayOf(groupShape).isRequired,
  isHidden: PropTypes.bool.isRequired,
  isInitiallyExpanded: PropTypes.bool.isRequired,
  isShowingMore: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  numAppliedFilters: PropTypes.number.isRequired,
  renderContentBeforeGroups: PropTypes.func.isRequired,
  showMoreOverlayTitle: PropTypes.string.isRequired
});
